<template>
  <div v-show="showHeaderMenu">
    <div class="d-flex md-stepper-horizontal">
      <div v-bind:class="[this.isActivePage(1) ? activeClass : '', notActiveClass]" v-on:click="goToInvitations">
        <div class="md-step-circle">
          <img src="/img/envelope-open-text-duotone-solid.svg"  class="sub-menu-card" alt="Invitations" />                        
        </div>
        <div class="md-step-title">Invitations</div>
        <div class="md-step-bar-left"></div>
        <div class="md-step-bar-right"></div>
      </div>
      <div v-bind:class="[this.isActivePage(3) ? activeClass : '', notActiveClass]" v-on:click="goToWave">
        <div class="md-step-circle">
          <img src="/img/calendar-clock-duotone-solid.svg"  class="sub-menu-card" alt="Waves" />                        
        </div>
        <div class="md-step-title">Waves</div>
        <div class="md-step-bar-left"></div>
        <div class="md-step-bar-right"></div>
      </div>
      <div v-bind:class="[this.isActivePage(6) ? activeClass : '', notActiveClass]" v-on:click="goToMetrics">
        <div class="md-step-circle">
          <img src="/img/chart-mixed-up-circle-dollar-duotone-solid.svg"  class="sub-menu-card" alt="Metrics" />                        
        </div>
        <div class="md-step-title">Metrics</div>
        <div class="md-step-bar-left"></div>
        <div class="md-step-bar-right"></div>
      </div>
      <div v-bind:class="[this.isActivePage(4) ? activeClass : '', notActiveClass]" v-on:click="goToClusters">
        <div class="md-step-circle">
          <img src="/img/layer-group-duotone-solid.svg"  class="sub-menu-card" alt="Groups" />                        
        </div>
        <div class="md-step-title">Groups</div>
        <div class="md-step-bar-left"></div>
        <div class="md-step-bar-right"></div>
      </div>
      <div v-bind:class="[this.isActivePage(5) ? activeClass : '', notActiveClass]" v-on:click="goToDownload">
        <div class="md-step-circle">
          <img src="/img/laptop-arrow-down-duotone-solid.svg"  class="sub-menu-card" alt="Download" />                        
        </div>
        <div class="md-step-title">Download</div>
        <div class="md-step-bar-left"></div>
        <div class="md-step-bar-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../../router";
import VueRouter from "vue-router";
import Vue from "vue";
import MenuMixins from "../../mixins/MenuMixins.vue";

export default {
  name: "RespondentMenu",
  components: {},
  mixins: [MenuMixins],
  router,
  props: {},
  data() {
    return {};
  },
  methods: {
    goToDownload: function() {
      if (this.$router.currentRoute.name != "respondent-download") {
        this.$router.replace({ path: "/respondent/download" });
      }
    },
    goToInvitations: function() {
      if (this.$router.currentRoute.name != "invitations") {
        this.$router.replace({ path: "/respondent/invitations" });
      }
    },
    goToClusters: function() {
      this.$router.replace({ name: "survey-group-list" });
    },
    goToWave: function() {
      this.$router.replace({ path: "/respondent/waves" });
    },
    goToMetrics: function() {
      this.$router.replace({ name: "metric-list" });
    }
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {}
};
</script>
